import { Component, HostListener, Inject } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { WINDOW } from "@ng-toolkit/universal";
import { GoogleTagManagerService } from "angular-google-tag-manager";

declare var $: any;
declare var gtag: any;

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"],
})
export class AppComponent {
	constructor(
		public router: Router,
		private gtmService: GoogleTagManagerService
	) {
		this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				gtag("config", "UA-139260511-2", {
					page_path: event.urlAfterRedirects,
				});
				this.gtmService.pushTag({
					event: "page",
					pageName: event.urlAfterRedirects,
				});
			}
		});
	}

	ngOnInit() {
		// Add custom CSS for cookie banner
		const style = document.createElement('style');
		style.innerHTML = `
			.cc-window { 
				padding: 8px !important; 
				min-height: 30px !important; 
				width: 100% !important; 
				max-width: 100% !important; 
				left: 0 !important; 
				right: 0 !important; 
				bottom: 0 !important;
				border-radius: 0 !important;
				display: flex !important;
				flex-direction: row !important;
				align-items: center !important;
				justify-content: space-between !important;
			}
			.cc-btn { 
				padding: 2px 6px !important; 
				font-size: 12px !important; 
				margin: 0 !important;
				white-space: nowrap !important;
			}
			.cc-message { 
				margin-right: 8px !important; 
				font-size: 16px !important; 
				margin: 0 !important;
			}
			.cc-compliance { 
				margin-left: 8px !important;
				flex-shrink: 0 !important;
			}
			/* Override any mobile-specific styles that might change the layout */
			@media screen and (max-width: 768px) {
				.cc-window {
					flex-direction: row !important;
				}
				.cc-message {
					margin-bottom: 0 !important;
				}
			}
		`;
		document.head.appendChild(style);

		let cc = window as any;
		cc.cookieconsent.initialise({
			palette: {
				popup: {
					background: "#111",
					text: "#fff",
				},
				button: {
					background: "#fff",
					text: "#111",
				},
			},
			theme: "block",
			content: {
				message:
					"Diese Seite verwendet Cookies. Mit der Nutzung akzeptieren Sie unsere Datenschutzrichtlinien.",
				dismiss: "OK",
			},
			position: "bottom"
		});
	}
}
